<template>
  <div :class="classDiv">
    <BTextInputWithValidation
      v-if="item.type === 'text' || item.type === 'number' || item.type === 'password' || item.type === 'email' || item.type === 'color'"
      :id="item.name"
      :value="formValue[item.name]"
      :form-value="formValue"
      :rules="item.validate"
      :type="item.type"
      :class="item.class"
      :name="item.name"
      :disabled="item.disabled"
      :readonly="item.readonly"
      v-bind="$attrs"
      :placeholder="item.placeholder"
      @update-value="($event) => $emit('update-value', $event)"
    />
    <BFileInputWithValidation
      v-if="item.type === 'file'"
      :id="item.name"
      :value="formValue[item.name]"
      :form-value="formValue"
      :rules="item.validate"
      :type="item.type"
      :class="item.class"
      :name="item.name"
      :disabled="item.disabled"
      v-bind="$attrs"
      :placeholder="item.placeholder"
      @update-value="($event) => $emit('update-value', $event)"
    />
    <BSelectWithValidation
      v-if="item.type === 'select'"
      :name="item.name"
      :value="item.value"
      :rules="item.validate"
      v-bind="$attrs"
    >
      <slot :slot-scope="formValue[item.name]" name="select-option" />
    </BSelectWithValidation>
    <BCheckboxesWithValidation
      v-if="item.type === 'checklist'"
      :name="item.name"
      :value="item.value"
      :rules="item.validate"
      :options="item.options"
      @update-value="($event) => $emit('update-value', $event)"
    >
      <span>{{ item.options && item.options.switches ? formValue[item.name] ? item.options.switchesChecked : item.options.switchesUnchecked : '' }}</span>
    </BCheckboxesWithValidation>
    <BCheckboxesWithValidation
      v-if="item.type === 'checklist' && item.options && item.options.group"
      :name="item.name"
      :value="item.value"
      :rules="item.validate"
      @update-value="($event) => $emit('update-value', $event)"
    >
      <b-form-checkbox v-for="ck in item.options.list" :key="ck.value" :value="ck.value">{{ ck.label }}</b-form-checkbox>
    </BCheckboxesWithValidation>
    <BRadioWithValidation
      v-if="item.type === 'radio'"
      :name="item.name"
      :value="item.value"
      :rules="item.validate"
      :options="item.options"
      @update-value="($event) => $emit('update-value', $event)"
    >
      <span>{{ item.options && item.options.switches ? formValue[item.name] ? item.options.switchesChecked : item.options.switchesUnchecked : '' }}</span>
    </BRadioWithValidation>
    <DatepickerWithValidation
      v-if="item.type === 'datepicker'"
      :name="item.name"
      :value="item.value"
      :rules="item.validate"
      :minute="item.options.minute"
      :confirm="item.options.confirm"
      :format="item.options.format"
      :type="item.options.type"
      :value-format="item.options.valueFormat"
      @update-value="($event) => $emit('update-value', $event)"
    >
    </DatepickerWithValidation>
  </div>
</template>


<script>
import BTextInputWithValidation from "@components/inputs/BTextInputWithValidation";
import BFileInputWithValidation from "@components/inputs/BFileInputWithValidation";
import BSelectWithValidation from "@components/inputs/BSelectWithValidation";
import BCheckboxesWithValidation from "@components/inputs/CheckboxesWithValidation";
import BRadioWithValidation from "@components/inputs/BRadioWithValidation";
import DatepickerWithValidation from "@components/inputs/DatepickerWithValidation";

export default {
  components: {
    BTextInputWithValidation,
    BFileInputWithValidation,
    BSelectWithValidation,
    BCheckboxesWithValidation,
    BRadioWithValidation,
    DatepickerWithValidation
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    formValue: {
      type: Object,
      default: () => {},
    },
    classDiv: {
      type: String,
      default: '',
    },
  },
}
</script>
